import { ckies } from '@ckies/library';

window.ckies = ckies;



/** WEBPACK FOOTER **
 ** ./webserver/document_root/s/js/common/ckies.esnext.js
 **/